/**
 * Placeholders a content author can write in an FAQ in Contentful, e.g. "call us on
 * {supportPhoneNumber}". FAQ entries aren't regional, so anything that varies by region is filled
 * in here, from the same source the rest of the site uses. See docs/howTos/faq-placeholders.md.
 */
export interface FaqPlaceholderValues {
  /** The customer service number the site shows this customer, e.g. 1300 88 99 00 in AU */
  supportPhoneNumber: string
}

function fillFaqPlaceholders(text: string, values: FaqPlaceholderValues): string {
  return Object.entries(values).reduce((filled, [name, value]) => filled.replaceAll(`{${name}}`, value), text)
}

export default fillFaqPlaceholders
